import i18next from 'i18next';

/** 서버가 보내는 오류 코드 모양. 문장이 아니라 코드일 때만 번역 키로 찾는다. */
const ERROR_CODE = /^[A-Z0-9][A-Z0-9_]*$/;

/**
 * 백엔드 오류 코드를 현재 언어로 번역.
 * - 응답 본문(`{resultMessage, resultParams}`)을 통째로 받거나 코드 문자열만 받는다
 * - `resultParams` 의 값은 번역문의 {{변수}} 에 채운다
 * - `resultParams.items` 가 있으면 줄마다 `errors.<item.code>` 로 번역해 잇는다 (한도 초과처럼
 *   여러 사유를 한 번에 알리는 경우)
 * - 번역 키가 없는 코드는 "예상치 못한 오류" 문장에 코드를 붙여 보여준다. 코드만 보이면
 *   사용자는 읽을 수 없고, 코드를 버리면 문의할 때 원인을 찾을 수 없다
 * - 코드가 아닌 값은 그대로 반환한다
 *
 * @param {string|{resultMessage?: string, resultParams?: object}|null|undefined} input
 * @param {object} [params] - 코드 문자열을 넘길 때 함께 채울 값
 * @returns {string|null}
 */
export const resolveError = (input, params) => {
    const isBody = input !== null && typeof input === 'object';
    const code = isBody ? input.resultMessage : input;
    const values = (isBody ? input.resultParams : params) || {};
    if (!code) return null;

    if (Array.isArray(values.items) && values.items.length > 0) {
        return values.items.map((item) => translate(item.code, item)).join(' / ');
    }
    return translate(code, values);
};

const translate = (code, values) => {
    const key = `errors.${code}`;
    if (i18next.exists(key)) {
        return i18next.t(key, values);
    }
    if (ERROR_CODE.test(String(code))) {
        return `${i18next.t('errors.UNEXPECTED_ERROR')} (${code})`;
    }
    return code;
};
